import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap";
import { FaProjectDiagram, FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { ServerAddress } from "../../../constants/ServerAddress";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toTitleCase from "../../../lib/titleCase/TitleCase";

const ProjectAllocation = () => {
  const navigate = useNavigate();
  const AccessToken = useSelector((state) => state.authentication.access_token);
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showProjects, setShowProjects] = useState(true);

  const get_project = async () => {
    try {
      const resp = await axios.get(
        ServerAddress + `ems/get_projects/?search=&p=${page}&records=10`,
        { headers: { Authorization: `Bearer ${AccessToken}` } }
      );
      if (resp.data) {
        setProjects(resp.data.results);
        setTotalPages(Math.ceil(resp.data.count / 10));
      }
    } catch (err) {
      console.warn(`Error Occurred in Get: ${err}`);
    }
  };

  useEffect(() => {
    get_project();
  }, [page]);

  return (
    <div
      style={{
        width: "100%",
        maxHeight: "500px",
        fontFamily: "sans-serif",
        border: "1px solid #ddd",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Card className="w-100 h-100" style={{ flex: "1 1 auto", overflow: "hidden" }}>
        <CardHeader
          style={{
            backgroundColor: "#004085",
            color: "#fff",
            padding: "5px 8px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center w-100">
            <CardTitle
              tag="h6"
              className="mb-0 d-flex align-items-center"
              style={{ fontSize: "16px" }}
            >
              <FaProjectDiagram className="me-2" /> Projects
            </CardTitle>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                style={{
                  backgroundColor: "#ffffff",
                  color: "#004085",
                  border: "none",
                  padding: "3px 6px",
                  borderRadius: "4px",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/ems/project")}
              >
                New Project
              </button>

              <button
                onClick={() => setShowProjects((prev) => !prev)}
                style={{
                  backgroundColor: "#fff",
                  color: "#004085",
                  border: "none",
                  padding: "3px 5px",
                  borderRadius: "100%",
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                }}
              >
                {showProjects ? <FaMinusCircle /> : <FaPlusCircle />}
              </button>
            </div>
          </div>
        </CardHeader>

        <div
          style={{
            overflowX: "auto",
            overflowY: "auto",
            padding: "8px",
            flex: "1 1 auto",
          }}
        >
          {showProjects && (
            <CardBody style={{ padding: "0px" }}>
              {projects?.map((project) => (
                <div
                  key={project.id}
                  className="project-card mb-2 p-2"
                  style={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: "4px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <h6 className="mb-0" style={{ fontSize: "14px" }}>
                      {project.project_name}
                    </h6>
                    <small className="text-muted" style={{ fontSize: "12px" }}>
                      Start On: {project.start_date}
                    </small>
                  </div>
                  <div className="project-team">
                    <small className="text-muted" style={{ fontSize: "12px" }}>
                      Project Lead: {toTitleCase(project.lead_firstname)}{" "}
                      {toTitleCase(project.lead_middlename)}{" "}
                      {toTitleCase(project.lead_lastname)}
                    </small>
                  </div>
                </div>
              ))}
            </CardBody>
          )}
        </div>

        {/* Pagination Footer (Fixed at bottom inside the card) */}
        <div
          className="d-flex tw-pt-[4px] tw-pr-[10px] tw-pb-[4px] tw-pl-[10px] tw-justify-between"
          style={{
            borderTop: "1px solid #ccc",
            padding: "6px 10px",
            backgroundColor: "#f1f1f1",
          }}
        >
          <Button
            color="primary"
            size="sm"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className="me-2"
          >
            Prev
          </Button>
          <span style={{ lineHeight: "32px", fontSize: "14px" }}>
            Page {page} of {totalPages}
          </span>
          <Button
            color="primary"
            size="sm"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
            className="ms-2"
          >
            Next
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ProjectAllocation;
